import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const defaultPort = 5001;

export default function SubscriptionAlert() {
  const [validity, setValidity] = useState(null);
  const [showValidityAlert, setShowValidityAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('https://pdks.bytebridge.com.tr/api-validity', { params: { port: defaultPort } })
      .then(res => {
        if (res.data && res.data.success === false) {
          setShowValidityAlert(true);
          setValidity(null);
          return;
        }
        if ((res.data && res.data.valid_until)) {
          setValidity(res.data.valid_until);
          const now = new Date();
          const validDate = new Date(res.data.valid_until.replace(' ', 'T'));
          if (validDate - now < 7 * 24 * 60 * 60 * 1000 || validDate < now) {
            setShowValidityAlert(true);
          }
        }
        if (!(res.data && res.data.valid_until)) {
          setShowValidityAlert(true);
          setValidity(null);
        }
      })
      .catch((err) => {
       
        setShowValidityAlert(true);
      });
  }, []);

  const handleValidityAlertClick = () => {
    setShowValidityAlert(false);
    navigate('/payment');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Snackbar
      open={showValidityAlert}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={() => setShowValidityAlert(false)}
      autoHideDuration={null}
      style={{ zIndex: 20000 }}
    >
      <Alert
        onClick={handleValidityAlertClick}
        severity="warning"
        sx={{ cursor: 'pointer', minWidth: 320, fontSize: 18, fontWeight: 'bold', boxShadow: 4 }}
        variant="filled"
      >
        {validity ? (
          new Date(validity.replace(' ', 'T')) < new Date()
            ? <>Abonelik süreniz <b>{validity}</b> tarihinde sona ERMİŞ. Ödeme yapmak için tıklayın.</>
            : <>Abonelik süreniz <b>{validity}</b> tarihinde sona erecek. Ödeme yapmak için tıklayın.</>
        ) : (
          <>Abonelik süresi bitmiş! Ödeme yapmak için tıklayın.</>
        )}
      </Alert>
    </Snackbar>
  );
}

// NOT: useNavigate hook'unu sadece Router context'i içindeki componentlerde kullanabilirsin. Eğer SubscriptionAlert App.js'de <AuthProvider> içinde ama <Router> dışında ise, navigate çalışmaz ve app çöker.
// Çözüm: SubscriptionAlert'i <Router> içine, <Routes> dışına koy!
